import { createContext } from "react";
const MenuRendererItemContext = createContext(null);
export {
  MenuRendererItemContext
};
